import React from "react";
import OfficersAttornyLayout from "./components/OfficersAttornyLayout";
import OfficersAndPowerOfAttornyTable from "./components/OfficersAndPowerOfAttornyTable";
import "./officers-attorny.scss";
import useOfficersAttornyRegistry from "./useOfficersAttornyRegistry";
import { Card } from "primereact/card";
import CustomeButton from "~/components/Button";
import AdminOnly from "~/components/AdminOnly";
const OfficersAttornyRegistry = ({ type }) => {
  const {
    search,
    setSearchQuery,
    data,
    loading,
    isDataAvailable,
    totalRecord,
    onPageChange,
    rows,
    page,
    isUserRegestered,
    sortMeta,
    onSort,
    handleNavigate,
  } = useOfficersAttornyRegistry({ type });
  return (
    <OfficersAttornyLayout type={type}>
      <h1 className="heading">
        {type === "officer" ? "Officer Registry" : "Attorney Registry"}
      </h1>
      <p className="description">
        {type === "officer"
          ? "Maintain a complete and accurate record of officers associated with this entity. Add, edit, and organize officer details and documents for compliance and reference"
          : "Maintain a complete and accurate record of Power of Attorney associated with this entity. Add, edit, and organize Power of Attorney details and documents for compliance and reference"}
      </p>
      <div className="flex mb-5">
        <div className="input-wrapper-container width__full flex-1">
          <span className="pi pi-search"></span>
          <input
            type="text"
            placeholder={
              type === "officer"
                ? "Search Officers by given name, surname or role"
                : "Search Power of Attorney by given name, surname or role"
            }
            className="appearance-none outline-none w-full"
            value={search}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <AdminOnly>
          <CustomeButton
            label={type === "officer" ? "Add Officer" : "Add Attorney"}
            variant="contained"
            className="access-btn"
            icon="pi pi-plus"
            iconPos="right"
            onClick={handleNavigate}
          />
        </AdminOnly>
      </div>
      <Card className="gen-card">
        <OfficersAndPowerOfAttornyTable
          search={search}
          data={data}
          loading={loading}
          isDataAvailable={isDataAvailable}
          totalRecords={totalRecord}
          onPageChange={onPageChange}
          type={type}
          isUserRegestered={isUserRegestered}
          rows={rows}
          page={page}
          sortMeta={sortMeta}
          onSort={onSort}
          handleNavigate={handleNavigate}
        />
      </Card>
    </OfficersAttornyLayout>
  );
};

export default OfficersAttornyRegistry;
